import { Suspense, lazy } from 'react';
import EmployeeData from './pages/EmployeeData';
import Landing from './pages/Landing';
import Loading from './pages/Loading';
import { Navigate, Route, Routes } from 'react-router-dom';

/*
 * 🔴 Die Konsole wird NACHGELADEN, nicht mitgebündelt.
 *
 * Gemessen am 16.09.2026 an der Produktionskarte: 244 kB App-Bündel, davon
 * 175 kB ungenutzt — im Wesentlichen /admin, /config und /editor, die jeder
 * öffentliche Kartenaufruf mitlud. Der Browser muss das parsen und ausführen,
 * bevor er etwas malen kann: das Porträt war nach 824 ms vollständig geladen,
 * der LCP lag trotzdem bei 3,0 s.
 *
 * `ConsoleProviders` ist bewusst mit drin — der Provider-Stack (Theme, Auth,
 * Marke) gehört zur Konsole, nicht zum Viewer. Der Viewer-Zweig unten bleibt
 * ein statischer Import: er IST der heiße Pfad, ein Nachladen kostete ihn eine
 * zusätzliche Umlaufzeit.
 *
 * `App.test.tsx` hält den Schnitt fest.
 */
const ConsoleProviders = lazy(() =>
    import('./editor/ConsoleProviders').then((m) => ({ default: m.ConsoleProviders })),
);
const MagicLoginPage = lazy(() =>
    import('./editor/pages/MagicLoginPage').then((m) => ({ default: m.MagicLoginPage })),
);
const AdminRoutes = lazy(() =>
    import('./editor/routes/AdminRoutes').then((m) => ({ default: m.AdminRoutes })),
);
const ConfigRoutes = lazy(() =>
    import('./editor/routes/ConfigRoutes').then((m) => ({ default: m.ConfigRoutes })),
);
const EditorRoutes = lazy(() =>
    import('./editor/routes/EditorRoutes').then((m) => ({ default: m.EditorRoutes })),
);

function App()
{
    return (
        <Routes>
            {/* Öffentliche Produktseite (außerhalb des Console-Provider-Stacks). */}
            <Route index element = {<Landing/>}/>

            {/* Konsole: ein gemeinsamer Provider-Stack (Theme/Auth/Brand) über
                /admin/* + /config/* + /editor/* (TP2 §D2, Bereichs-Split
                Task 8). Statische Segmente schlagen die dynamische :urlKey-
                Viewer-Route (React Router rankt nach Spezifität, unabhängig von
                der Deklarationsreihenfolge — deshalb ist die dynamische Route
                unten trotzdem sicher). Getrennte Logins pro Bereich (F2-Split),
                alle drei reiner Magic-Link-Flow: /admin/login (+ optionaler
                Keycloak-Button), /config/login, /editor/login. Der alte
                zentrale /login bleibt als Bookmark-Redirect auf den
                Admin-Login bestehen. /anmeldelink löst den Magic-Link-Token
                per POST ein (Task 7).

                /anmeldelink lag BIS Task-14-Abnahme (2026-08-06) unter
                /auth/magic — das kollidierte mit dem Backend-Controller-Präfix
                /auth: ServeStaticModules exclude schließt /auth{/*path} komplett
                von der SPA-Auslieferung aus (damit echte Backend-Routen wie
                /auth/me nicht von Static überschattet werden), traf damit aber
                auch diese reine Frontend-Route — ein Mail-Klick landete auf
                einer rohen 404 statt der SPA. /anmeldelink liegt außerhalb
                jedes Controller-Präfixes (Liste: `BACKEND_PREFIXES` in
                backend/src/config/reserved-paths.ts) und ist wie /admin,
                /config, /editor, /login ein RESERVIERTES Wort auf
                oberster Ebene: ein vCard-Slug
                (:urlKey) mit exakt diesem Namen wäre am Root dauerhaft
                unerreichbar (von der statischen Route verdeckt). Es gibt
                aktuell KEINE Reserved-Words-Prüfung bei der Slug-Vergabe
                (backend/src/utils/slug.util.ts) — das gilt bereits für admin/
                config/editor/login genauso und ist ein vorbestehender,
                eigenständiger Punkt, kein Regressionsrisiko dieser Änderung.
                (/error entfiel mit T-29: 404/410 werden seither inline über
                TemplateLoader gerendert, keine eigene Route mehr.) */}
            <Route element = {<Suspense fallback = {<Loading/>}><ConsoleProviders/></Suspense>}>
                <Route path = 'login' element = {<Navigate to = '/admin/login' replace/>}/>
                <Route path = 'anmeldelink' element = {<MagicLoginPage/>}/>
                <Route path = 'admin/*' element = {<AdminRoutes/>}/>
                <Route path = 'config/*' element = {<ConfigRoutes/>}/>
                <Route path = 'editor/*' element = {<EditorRoutes/>}/>
            </Route>

            {/* Öffentlicher Viewer (dynamisch, zuletzt im Ranking). */}
            <Route path = ':urlKey' element = {<EmployeeData/>}/>
        </Routes>
    )
}

export default App;
